import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import authReducer from './slices/auth.slice';
import themeReducer from './slices/theme.slice';
import saquesReducer from './slices/saques.slice';
import usuariosReducer from './slices/usuarios.slice';
import clientesReducer from './slices/clientes.slice';
import clienteProdutosReducer from './slices/cliente-produtos.slice';
import clienteVendasReducer from './slices/cliente-vendas.slice';
import clienteTaxasReducer from './slices/cliente-taxas.slice';
import avisosReducer from './slices/avisos.slice';
import ajusteAntecipacaoReducer from './slices/ajuste-antecipacao.slice';

const rootReducer = combineReducers({
  auth: authReducer,
  theme: themeReducer,
  saques: saquesReducer,
  usuarios: usuariosReducer,
  clientes: clientesReducer,
  clienteProdutos: clienteProdutosReducer,
  clienteVendas: clienteVendasReducer,
  clienteTaxas: clienteTaxasReducer,
  avisos: avisosReducer,
  ajusteAntecipacao: ajusteAntecipacaoReducer,
});

const persistConfig = {
  key: 'vendepay-gestao',
  storage,
  whitelist: ['auth', 'theme'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
